import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";

import { AuthService } from "@azm/core/services/auth";

export const permissionsResolver: ResolveFn<string[]> = () => inject(AuthService).getUserPermissions();
